import React, { ComponentPropsWithRef, ReactElement, useRef, useEffect } from 'react'
import { useInViewport, useMemoizedFn } from 'ahooks'
import type { BaseTableProps } from '@jushuitan/ali-react-table/dist/base-table/table'
import { createInViewEventContext } from '@/modules/globals/utils/createInViewEventContext'

/** 创建处理 `Table` 组件行元素的 `InView` 事件上下文 */
const RowInViewEventContext = createInViewEventContext()

/** `Table` 组件行元素的 `InView` 事件的上下文提供者 */
export const RowInViewEventProvider = RowInViewEventContext.Provider

/** 自定义 `Table` 的 `Row` 组件的属性 */
export type RowProps = ComponentPropsWithRef<NonNullable<NonNullable<BaseTableProps['components']>['Row']>>

/**
 * 自定义 `Table` 的 `Row` 组件实现 `InView` 事件的监听和收集
 * @see [自定义表格内的子组件 - ali-react-table](https://ali-react-table.js.org/docs/table/api/#%E8%87%AA%E5%AE%9A%E4%B9%89%E8%A1%A8%E6%A0%BC%E5%86%85%E7%9A%84%E5%AD%90%E7%BB%84%E4%BB%B6)
 */
export function RowInView({ row, trProps }: RowProps): ReactElement {
    const ref = useRef(null)
    const { event$, options } = RowInViewEventContext.useContext()
    const inViewportInfo = useInViewport(ref, options)

    const handleInViewportStatusChange = useMemoizedFn(() => {
        const [isInView, ratio] = inViewportInfo
        event$.emit({ isInView, ratio, data: row })
    })

    useEffect(() => {
        handleInViewportStatusChange()
    }, [handleInViewportStatusChange, inViewportInfo])

    return <tr ref={ref} {...trProps} />
}
